import React from 'react';
import { format, parseISO } from 'date-fns';

export function DateCell(date: string | Date) {
  let parsedDate: Date;
  if (typeof date === 'string') {
    parsedDate = parseISO(date);
  } else if (date instanceof Date) {
    parsedDate = date;
  } else {
    throw Error('DateCell expects a string or a Date object.');
  }

  const dateFormatted = format(parsedDate, 'do MMM yyyy');
  return <time dateTime={dateFormatted}>{dateFormatted}</time>;
}
